import React, { useState } from "react";
import ReactMapGL, { Marker, setRTLTextPlugin } from "react-map-gl";
import { MAP_RTL_CODE, MAP_TOKEN } from "configs/constants";
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "mapbox-gl";
const Map = () => {
  const [lat, setlat] = useState(35.72802990453984);
  const [lng, setlng] = useState(51.31927337568839);
  const [viewport, setViewport] = React.useState({
    latitude: lat,
    longitude: lng,
    zoom: 12,
    width: "100%",
    height: "22.5rem",
  });
  React.useEffect(() => {
    if (mapboxgl.getRTLTextPluginStatus() !== "loaded") {
      setRTLTextPlugin(MAP_RTL_CODE);
    }
  }, []);
  return (
    <div>
      <ReactMapGL
        {...viewport}
        mapboxApiAccessToken={MAP_TOKEN}
        onViewportChange={(mv: any) => setViewport(mv)}
      >
        <Marker key={5} latitude={lat} longitude={lng}>
          <i className="icon-location  icon-location-lg " />
        </Marker>
      </ReactMapGL>
    </div>
  );
};

export default Map;
